import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default props => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>POST api/anonymous/me</h1>
        </div>
        <p>
          Update current anonymous account on Avaya Spaces. Returns a unique
          JSON of updated anonymous user.
        </p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>displayname</td>
                <td>The user's full name</td>
                <td>String</td>
                <td>No</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authorization</h2>
        <p>None required.</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/anonymous/me
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: 'jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg'
        </pre>
        <h4>Body</h4>
        <pre className="json">
{`{
        "displayname": "anonymous ab",
}`}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
{`{
  "aType": "anonymous",
  "_id": "5f1ea956a4cc6808b4981b63",
  "displayname": "anonymous ab",
  "username": "anonymous ab",
  "created": "2020-07-27T10:15:50.873Z",
  "picture_url": "https://accounts.zang.io/norevimages/noimage-anonymous.jpg",
  "profile": {
      "displayname": "anonymous ab",
      "username": "anonymous ab",
      "picture_url": "https://accounts.zang.io/norevimages/noimage-anonymous.jpg"
  }
}
`}
        </pre>
      </div>
    </div>
  </Layout>
)
